import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@talbenmoshe/prometheus-react-app-runtime';
import { ParentTheme, ThemeProvider } from '@talbenmoshe/naru-parent-design-system';
import '@talbenmoshe/naru-parent-design-system/styles.css';
import { routeTree } from './.autogen/routeTree.gen.js';
import { createAppTranslator } from './i18n/createAppTranslator.js';
import { MessagesProvider } from './i18n/messagesContext.js';
import { ShellInitialDataReader } from './initialData/ShellInitialDataReader.js';
import { SiteLinksContext } from './SiteLinksContext.js';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

async function bootstrap(): Promise<void> {
  const root = document.getElementById('root');

  if (!root) {
    throw new Error('Root element not found');
  }

  const { messages, localeController, localeSwitcher } = await createAppTranslator();
  const dashboardAppUrl = new ShellInitialDataReader(window).readDashboardAppUrl();

  ReactDOM.createRoot(root).render(
    <StrictMode>
      <MessagesProvider messages={messages} localeController={localeController} localeSwitcher={localeSwitcher}>
        <SiteLinksContext.Provider value={dashboardAppUrl}>
          <ThemeProvider theme={ParentTheme.LIGHT}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </SiteLinksContext.Provider>
      </MessagesProvider>
    </StrictMode>
  );
}

bootstrap();
